import React, {FC, useCallback} from 'react';
import {Button} from '@lookiero/aurora';
import {PersonalShopperDialog} from '../_components/PersonalShopperDialog/PersonalShopperDialog';
import {TEXT} from './CheckoutDialog.definition';
import {useIntl} from 'react-intl';
import {useNavigate} from 'react-router-native';
import {Path} from '@modules/routing/routes.definition';
import {eventManager} from '@application/Event';
import {MyLookieroActionEvent} from '@domain/model/Event';
import {PageEventView} from '@domain/model/Event/domain/model/UiEvents';

export const CheckoutDialog: FC<{username: string}> = ({username}) => {
  const {formatMessage} = useIntl();
  const navigate = useNavigate();

  const goToCheckout = useCallback(() => {
    eventManager.emit(MyLookieroActionEvent.OPEN_CHECKOUT, {view: PageEventView.PLACED_ORDER});
    navigate(Path.CHECKOUT_HOME);
  }, [navigate]);

  return (
    <PersonalShopperDialog testID="checkout-dialog" message={formatMessage(TEXT.CHECKOUT_MESSAGE, {username})}>
      <Button onPress={goToCheckout} testID="checkout-available-button" nativeID="checkout-available-button">
        {formatMessage(TEXT.CHECKOUT_CTA)}
      </Button>
    </PersonalShopperDialog>
  );
};
